import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    visibilityControl: String,
    liveRegionMessage: String
  }

  static targets = [
    'hiddenWrapper',
    'radioInput'
  ]

  connect() {
    this.toggleHiddenWrapperOnCheckedRadio()
    this.liveRegion = document.getElementById('live-region-polite')
  }

  toggleHiddenWrapperOnCheckedRadio() {
    const checkedRadio = this.radioInputTargets.find(radio => radio.checked)
    if (checkedRadio) {
      this.toggleHiddenWrapper(checkedRadio.value)
    }
  }

  handleRadioInputChange({ target }) {
    this.toggleHiddenWrapper(target.value)
    if (this.visibilityControlValue === 'false' && this.liveRegionMessageValue) {
      this.liveRegion.textContent = this.liveRegionMessageValue
    }
  }

  toggleHiddenWrapper(value) {
    const shouldShow = value === this.visibilityControlValue

    if (this.hasHiddenWrapperTarget) {
      if (shouldShow) {
        this.hiddenWrapperTarget.classList.remove('d-none')
      } else {
        this.hiddenWrapperTarget.classList.add('d-none')
      }
    }
  }
}
